import Select from "react-select";
import BaseListPage from "../../base/BaseListPage";
import withRouter from "../../withRouter";
import { countObjectUseCase, findObjectUseCase } from "../../usecases/object";
import { computationHelper, exportReportCSV } from "./utils/reportHelpers";
import { exportCSVUseCase } from "../../usecases/csv/usecases";
import ReportPresenter from "./ReportPresenter";
import DefaultState from "../sales-and-transactions/components/DefaultState";
import DateRangeReport from "../../components/DateRangeReport";
import NavBar2 from "../../components/NavBar2";
import ReportSummary from "./components/ReportSummary";
// import ReportTable from "./components/ReportTable";
import ProgressLoader from "../../components/ProgressLoader";
import ReportTable from "./components/ReportTable";

class ReportPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new ReportPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      exportCSVUseCase()
    );
    this.state = {
      objects: [],
      count: 0,
      aggregatedData: {},
      store: [],
      startDate: "",
      endDate: "",
      range: "",
      storess: "",
      storeCode: "",
      notFound: false,
    };
  }

  getCollectionName() {
    return "transactions";
  }

  componentDidMount() {
    this.presenter.componentDidMount();
  }

  onChangeDate(where) {
    const { tran_date } = where;
    const start = tran_date?.$gte ? new Date(tran_date.$gte) : new Date();
    const end = tran_date?.$lte ? new Date(tran_date.$lte) : new Date();

    if (start.toDateString() === end.toDateString()) {
      end.setHours(23, 59, 59, 999);
    }
    const startDate = start.toLocaleDateString();
    const endDate = end.toLocaleDateString();
    this.state.aggregatedData = {};
    this.setState({ range: where, startDate, endDate });
    this.presenter.onChangeDate(where);
  }
  onChangeStore(where) {
    this.state.aggregatedData = {};
    this.setState({ storess: where });
    this.presenter.onChangeStore(where);
  }
  setStore(store) {
    this.setState({ store });
  }

  onClickExport() {
    const { objects, aggregatedData, startDate, endDate } = this.state;
    exportReportCSV({ aggregatedData, objects, startDate, endDate });
  }

  getProgressPercentage() {
    const { objects, count } = this.state;
    if (!count || count === 0) return 0;
    return Math.min(Math.round((objects.length / count) * 100), 100);
  }

  setNotFound(notFound) {
    this.setState({ notFound });
  }

  render() {
    const { aggregatedData, objects } = this.state;
    const objectss = this.state?.objects?.filter((obj) => obj.status === "C");
    console.log("Transactions cc:", objectss);
    console.log("Transaction:", objects);
    console.log("aggregatedData", aggregatedData);
    const { totals, voidTotals } = computationHelper(aggregatedData, objects);

    return (
      <>
        <NavBar2 />
        <div className="">
          <ReportSummary
            totals={totals}
            voidTotals={voidTotals}
            aggregatedData={aggregatedData}
            store={this.state.storess}
            exportCSV={this.onClickExport.bind(this)}
          />

          <div className="p-3 p-lg-4">
            <div className="d-flex justify-content-between align-items-center">
              <h1
                className="fw-bold mt-2 text-capitalize"
                style={{ color: "#83c14a" }}
              >
                Report Analytics
              </h1>
            </div>
            <div className="row mb-2">
              <div className="col-sm-4" style={{ maxWidth: "max-content" }}>
                <DateRangeReport
                  onChange={this.onChangeDate.bind(this)}
                  field="tran_date"
                />
              </div>

              <div className="col-sm-4">
                <Select
                  options={[
                    { value: "AllStore", label: "All Store" },
                    ...this.state.store.map((code) => ({
                      value: code.name,
                      label: code.name,
                    })),
                  ]}
                  onChange={(selectedOption) => {
                    this.onChangeStore(selectedOption.value);
                    this.setState({ storeCode: selectedOption.value });
                  }}
                  isDisabled={!this.state.range}
                  placeholder="Select Store"
                  value={this.state.store
                    .map((code) => ({
                      value: code.name,
                      label: code.name,
                    }))
                    .find((option) => option.value === this.state.storeCode)}
                />
              </div>
            </div>

            {!this.state.range || !this.state.storess ? (
              <div className="text-center align-items-center mt-4">
                <img
                  src="./choosefirst.png"
                  style={{ height: "200px", width: "200px" }}
                />
                <h4 className="mt-4 fw-semibold text-muted text-center">
                  👋 To get started, please select a{" "}
                  <span className="text-success">date range</span> and{" "}
                  <span className="text-success">store</span> above.
                </h4>
              </div>
            ) : this.state.notFound ? (
              <div className="text-center mt-5">
                <h4 className="text-muted">
                  📭 Data not found for selected filter.
                </h4>
              </div>
            ) : Object.keys(aggregatedData).length === 0 ? (
              <div className="text-center mt-5">
                <DefaultState />
                <ProgressLoader
                  loaded={this.state.objects.length}
                  total={this.state.count}
                  getProgressPercentage={() => this.getProgressPercentage()}
                />
              </div>
            ) : (
              <div className="overflow-auto row mt-1 g-3">
                <ReportTable
                  aggregatedData={aggregatedData}
                  totals={totals}
                  voidTotals={voidTotals}
                />
              </div>
            )}
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(ReportPage);
